module.exports = __webpack_public_path__ + "assets/img/c5d5479108efdeddb93299a7486bc021.png";